import jwt_decode from 'jwt-decode'

export const PUBLIC_HOMEWORK_SESSION_KEY = 'publicHomeworkSession'

export const isPublicHomeworkPath = (pathname = '') =>
  /^\/home-work\/work-[^/]+/.test(pathname)

// localStorage, а не sessionStorage: метка должна пережить новую вкладку и
// перезапуск браузера, иначе токен скрытого ученика останется, а платформа
// откроется его кабинетом
export const hasPublicHomeworkSession = () => {
  try {
    return localStorage.getItem(PUBLIC_HOMEWORK_SESSION_KEY) === '1'
  } catch (error) {
    return false
  }
}

export const startPublicHomeworkSession = () => {
  try {
    localStorage.setItem(PUBLIC_HOMEWORK_SESSION_KEY, '1')
  } catch (error) {
    // приватный режим: метку не сохранить, публичный урок всё равно откроется
  }
}

export const endPublicHomeworkSession = () => {
  try {
    localStorage.removeItem(PUBLIC_HOMEWORK_SESSION_KEY)
  } catch (error) {
    // нечего чистить
  }
}

// Скрытый кабинет публичной ссылки. Признак берём из JWT: он не зависит от того,
// перезаписал ли какой-нибудь экран profile, и переживает обновление токена
export const isPublicHomeworkUser = () => {
  try {
    const token = localStorage.getItem('userToken')

    return token ? Boolean(jwt_decode(token)?.is_public) : false
  } catch (error) {
    return false
  }
}
